import reservation from "../assets/reservation.png";
import chef from "../assets/cc.png";
import gallery01 from "../assets/G1.jpg";
import gallery02 from "../assets/G2.jpg";
import gallery03 from "../assets/G3.jpg";
import gallery04 from "../assets/G4.jpg";
import gallery05 from "../assets/G5.jpg";
import gallery06 from "../assets/G6.jpg";
import menu from "../assets/Menu.jpg";
import welcome from "../assets/Home.png";
import findus from "../assets/C.png";
import sign from "../assets/sign.png";
import Medit from "../assets/Medit.png";
import spn from "../assets/spn.png";

export const galleryData = [
  {
    img: gallery01,
    title: "Fresh Mezze",
    desc: "A colorful spread of authentic Mediterranean flavors.",
  },
  {
    img: gallery02,
    title: "Creamy Hummus",
    desc: "Smooth, rich, and made from the finest chickpeas.",
  },
  {
    img: gallery03,
    title: "Warm Pita",
    desc: "Soft, fluffy bread baked fresh every day.",
  },
  {
    img: gallery04,
    title: "Mediterranean Soul",
    desc: "Every dish tells a story of tradition and taste.",
  },
  {
    img: gallery05,
    title: "Golden Falafel",
    desc: "Crispy outside, soft inside — perfectly seasoned.",
  },
  {
    img: gallery06,
    title: "Healthy Bowls",
    desc: "Nutritious, vibrant, and full of natural goodness.",
  },
];

export default {
  reservation,
  chef,
  spn,
  gallery01,
  gallery02,
  gallery03,
  gallery04,
  gallery05,
  gallery06,
  menu,
  welcome,
  findus,
  sign,
  Medit,
};
